export default "__VITE_ASSET__9NDxTJa1__"